(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6525],{

/***/ 46889:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers",
      function () {
        return __webpack_require__(31425);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90179);
/* harmony import */ var _components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_Products_Products_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49879);
/* harmony import */ var _components_Products_Products_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_components_Products_Products_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_common_Navbar_Navbar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77911);
/* harmony import */ var _components_common_Footer_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5945);
/* harmony import */ var _components_common_CallToAction_FooterCallToAction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16314);
/* harmony import */ var _components_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20026);
/* harmony import */ var _components_common_Buttons_PrimaryButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29204);









const Customers = (param)=>{
    let { customers  } = param;
    const expandedCustomers = customers.slice(0, 6);
    const allCustomersLogos = [
        "pipe",
        "portal",
        "dripos",
        "knock",
        "hightouch",
        "basedash",
        "impira",
        "mage",
        "airplane",
        "examedi",
        "guruhotel",
        "hotplate",
        "writesonic",
        "tributi",
        "superpowered",
        "sunsama",
        "cabal"
    ];
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Navbar_Navbar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().caseListLayout),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().caseListTitle),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_components_Products_Products_module_scss__WEBPACK_IMPORTED_MODULE_8___default().highlightedBadge),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                                            type: "copy4",
                                            emphasis: true,
                                            children: "Customer Case Studies"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                        children: [
                                            "What ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().limeAccent),
                                                children: "our customers"
                                            }),
                                            " have to say."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Buttons_PrimaryButton__WEBPACK_IMPORTED_MODULE_6__/* .PrimaryButton */ .K, {
                                        children: "Get started for free"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().caseList),
                                children: expandedCustomers.map((c)=>{
                                    var ref1, ref2;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomerCaseCard, {
                                        logo: (ref1 = c.companyLogo) === null || ref1 === void 0 ? void 0 : ref1.url,
                                        author: "".concat(c.primaryQuote.author.firstName, " ").concat(c.primaryQuote.author.lastName),
                                        quote: c.primaryQuote.body,
                                        role: c.primaryQuote.author.title,
                                        slug: c.slug,
                                        thumbnail: (ref = (ref2 = c.image) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref !== void 0 ? ref : ""
                                    }, c.slug);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: "See all our customers"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().allCustomersGrid),
                                children: allCustomersLogos.map((name, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompanyLogo, {
                                        name: name
                                    }, i))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_CallToAction_FooterCallToAction__WEBPACK_IMPORTED_MODULE_4__/* .FooterCallToAction */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Footer_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        ]
    });
};
const CompanyLogo = (param)=>{
    let { name  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().allCustomersLogo),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "/images/companies/white-logos/".concat(name, ".png"),
            alt: "".concat(name, " logo"),
            layout: "fill",
            objectFit: "contain"
        })
    });
};
const CustomerCaseCard = (param)=>{
    let { thumbnail , logo , quote , author , role , slug  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().caseCard),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().thumbnail),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: thumbnail,
                    layout: "fill",
                    objectFit: "cover",
                    alt: "Case thumbnail"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().caseDetails),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().companyCaseLogo),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: logo,
                                    alt: "Company logo",
                                    layout: "fill",
                                    objectFit: "contain",
                                    objectPosition: "left"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().caseCardQuote),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().leftQuote),
                                                children: "“"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                                                type: "copy2",
                                                onDark: true,
                                                children: quote
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().rightQuote),
                                                children: "”"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                                                type: "copy2",
                                                emphasis: true,
                                                children: [
                                                    author,
                                                    ","
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                                                type: "copy2",
                                                children: role
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Buttons_PrimaryButton__WEBPACK_IMPORTED_MODULE_6__/* .PrimaryButton */ .K, {
                        href: "/customers/".concat(slug),
                        className: (_components_Customers_CustomersList_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cardReadCaseButton),
                        children: "Read case study"
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Customers);


/***/ }),

/***/ 90179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"caseListLayout":"CustomersList_caseListLayout__z2WMc","caseListTitle":"CustomersList_caseListTitle__JeTHE","caseList":"CustomersList_caseList__ckunR","limeAccent":"CustomersList_limeAccent__8yaVg","caseCard":"CustomersList_caseCard__q2_Bb","thumbnail":"CustomersList_thumbnail__petN4","caseCardQuote":"CustomersList_caseCardQuote___So0O","leftQuote":"CustomersList_leftQuote__w2ord","rightQuote":"CustomersList_rightQuote__k2nVd","caseDetails":"CustomersList_caseDetails__Gwy3D","companyCaseLogo":"CustomersList_companyCaseLogo__p7FVf","cardReadCaseButton":"CustomersList_cardReadCaseButton__wCfre","allCustomersGrid":"CustomersList_allCustomersGrid__JEHR3","allCustomersLogo":"CustomersList_allCustomersLogo__r9zqd"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,3826,1003,2232,8179,3132,9774,2888,179], function() { return __webpack_exec__(46889); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);